<template>
    <section id="home" class="home home-image">
        <div class="overlay">
            <vue-particles color="#dedede" :particleOpacity="0.7" :particlesNumber="100" shapeType="circle"
                :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4"
                :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true"
                clickMode="push"></vue-particles>
            <navbar />
            <div class="container">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8 col-sm-12 child">
                        <div class="header-inner">
                            <div class="header-content">
                                <h1 class="main-title"> {{ $t('home.main_title') }}</h1>
                                <vue-typer v-if="!isAr" caret-animation='smooth' :text="$t('home.items')"
                                    :pre-type-delay='500' :type-delay='100' erase-style='backspace'
                                    :erase-delay='50'></vue-typer>
                                <v-typical class="blink" v-if="isAr" :steps="items" :loop="Infinity"
                                    :wrapper="'h2'"></v-typical>
                            </div>
                        </div>
                    </div>
                    <div class="mouse">
                        <div v-scroll-to="{
                            el: '#about',
                            offset: -66,
                            force: true,
                        }" class="scroll-btn light skrollable skrollable-between" data-offset="-55" data-0="opacity:1"
                            data-top-bottom="opacity:0;" title="Go Down" style="opacity: 0.902564;"><span></span></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import { VueTyper } from 'vue-typer';
import VTypical from 'vue-typical';
export default {
    name: "Home",
    components: {
        Navbar,
        VueTyper,
        VTypical,
    },
    data() {
        return {
            display: '',
            items: [
                "التفكير خارج الصندوق", 2000,
                "برمجة افكارك", 2000,
                "بناء مجتمعك", 2000
            ],
        };
    },
    computed: {
        isAr() {
            this.lang = localStorage.getItem("lang")
            return this.lang == 'ar'
        },
    },
    methods: {

    },
    mounted() {
    }

};
</script>

<style lang="scss">
.home .blink {
    margin-top: 30px;
    color: #fff;
    font-weight: 700;
}

.home .mouse {
    color: #fff;
}

@keyframes downup {
    0% {
        transform: translateY(0)
    }

    50% {
        transform: translateY(18px)
    }

    100% {
        transform: translateY(0)
    }

}

.home .scroll-btn {
    cursor: pointer;
    display: block;
    width: 24px;
    height: 38px;
    border: 2px solid #3e3e3e;
    position: absolute;
    bottom: 40px;
    left: 50%;
    z-index: 200;
    margin-left: -13px;
    border-radius: 12px;
    text-align: center;
    line-height: 0;
    transition: border .35s ease;
    -webkit-transition: border .35s ease;
}

.scroll-btn.light>span {
    background-color: #f1f1f1;
}

.scroll-btn.light {
    border-color: #f1f1f1;
}

.scroll-btn>span {
    display: inline-block;
    position: relative;
    margin: 5px 0;
    width: 2px;
    height: 6px;
    background-color: #4e4e4e;
    border-radius: 8px;
    -webkit-animation-name: downup;
    animation-name: downup;
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    transition: border .35s ease;
    -webkit-transition: border .35s ease;
}

.home {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: relative;
    overflow: hidden;
}

.home.home-image {
    background-image: url(../assets/img/wall8.webp);
    position: relative;
    height: 100vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.home #particles-js {
    width: 100%;
    height: 100%;
    position: absolute;
}

.home .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #12680167, #18223cb9);
}

.home .custom.char {
    color: #fff;
    font-size: 40px;
    font-weight: 700;
}

.home .vue-typer .custom.caret {
    width: 7px;
    background-color: #fff;
}

html:lang(en) .home .main-title {
    font-family: Saira, sans-serif;
    color: hsla(0, 0%, 100%, .89);
}

html:lang(ar) .home .main-title {
    color: hsla(0, 0%, 100%, .89);
}

.home .main-title {
    font-size: 50px;
    font-weight: 800;
}

@media (max-width: 991px) {
    html:lang(ar) .home .main-title {
        margin: 0px 10px 30px 40px;
    }
    .home .blink{
        font-size: 28px;
        margin-left: 20px
    }
    .home .vue-typer{    
        margin-right: 30px;
    }
}

@media (max-width: 991px) {
    .home .main-title {
        font-size: 30px;
        margin: 0px 40px 30px 10px;
    }

    .home .custom.char {
        font-size: 25px;
    }

    .home-image {
        height: 60% !important;
        background-position: 75% !important;
    }
}

.home .header-inner {
    display: flex;
    position: absolute;
    justify-content: center;
    top: 150px;
    width: 100%;
}

.home .header-content {
    z-index: 200;
}
</style>